import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const EmployerDescriptionWrapper = styled.div`
  width: 650px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  margin: 0 15px;
  height: fit-content;
  display: inline-block;
  padding: 25px 20px;

  ${mediaMaxWidth.tablet} {
    margin: 0px 10px 10px 10px;
  }

  ${mediaMaxWidth.phone} {
    padding: 15px 10px;
  }
`;

export const LogosWrapper = styled.div`
  display: flex;
`;

export const Logo = styled.div`
  display: flex;
  flex: 1;
`;

export const PortalLogoWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-end;

  svg {
    margin-left: 5px;
    color: rgb(187, 187, 187);
    font-size: 0.85em;
    cursor: pointer;
    position: relative;
    top: 6px;
  }

  .__react_component_tooltip {
    text-align: center;
    max-width: 310px;
  }
`;

export const PremiumLogoWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-end;

  svg {
    margin-left: 10px;
    color: rgb(187, 187, 187);
    font-size: 0.85em;
    cursor: pointer;
    position: relative;
    top: 6px;
  }

  .__react_component_tooltip {
    text-align: center;
    max-width: 310px;
  }
`;

export const CompanyLogo = styled.img`
  max-height: 90px;
  padding: 0 10px;
`;

export const PortalLogo = styled.img`
  height: 30px;
`;

export const PremiumLogo = styled.img`
  height: 27px;
`;

export const WebsiteWrapper = styled.div`
  display: flex;
  margin: 20px 10px 30px 10px;

  ${mediaMaxWidth.tablet} {
    flex-direction: column;
  }
`;

export const WebsiteLink = styled.a`
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  flex: 1;
  transition: 0.1s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }

  &:focus {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${mediaMaxWidth.tablet} {
    margin-bottom: 20px;
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;
